import styled from 'styled-components/macro'
import Grid from '@material-ui/core/Grid'

const Wrapper = styled(Grid)``

export default Wrapper
